var _path, _path2, _path3, _path4, _path5, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndianicShortLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3571 39.9075C14.9586 39.9075 10.0708 37.7189 6.53255 34.1806C2.9943 30.6429 0.805664 25.7551 0.805664 20.3561C0.805664 14.9577 2.9943 10.0698 6.53255 6.53157C10.0708 2.99333 14.9586 0.804688 20.3571 0.804688C24.1858 0.804688 27.7576 1.90561 30.7732 3.80815L29.5578 5.30631C29.2299 5.71069 28.9856 6.13984 28.8222 6.6009C28.7832 6.71038 28.7491 6.82152 28.7193 6.93321C26.2936 5.41855 23.4277 4.54375 20.3571 4.54375C15.9908 4.54375 12.0372 6.3137 9.17564 9.17467C6.31467 12.0362 4.54473 15.9898 4.54473 20.3561C4.54473 24.7229 6.31467 28.676 9.17564 31.5375C12.0372 34.3985 15.9908 36.1684 20.3571 36.1684C24.7239 36.1684 28.677 34.3985 31.5385 31.5375C34.3995 28.676 36.1694 24.7229 36.1694 20.3561C36.1694 17.2861 35.2946 14.4196 33.7799 11.9938C33.8916 11.9641 34.0022 11.93 34.1123 11.8909C34.5733 11.7275 35.0025 11.4832 35.4068 11.1553L36.905 9.93997C38.8076 12.9555 39.9085 16.5273 39.9085 20.3561C39.9085 25.7551 37.7198 30.6424 34.1816 34.1806C30.6433 37.7189 25.756 39.9075 20.3571 39.9075Z",
    fill: "#6699FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.357 25.9118C18.8231 25.9118 17.4339 25.2901 16.4287 24.2849C15.4235 23.2791 14.8013 21.8905 14.8013 20.3566C14.8013 18.8226 15.4235 17.434 16.4287 16.4282C17.4339 15.423 18.8231 14.8008 20.357 14.8008C20.9683 14.8008 21.5565 14.8998 22.1066 15.0825L18.5948 18.5943C17.6215 19.5676 17.6215 21.1455 18.5948 22.1188C19.5681 23.0921 21.146 23.0921 22.1193 22.1188L25.6311 18.607C25.8138 19.1572 25.9123 19.7453 25.9123 20.3566C25.9123 21.8905 25.2906 23.2791 24.2854 24.2849C23.2796 25.2901 21.891 25.9118 20.357 25.9118Z",
    fill: "#6699FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3569 32.8202C16.9154 32.8202 13.7997 31.4254 11.5445 29.1697C9.28876 26.9145 7.89404 23.7988 7.89404 20.3573C7.89404 16.9159 9.28876 13.8002 11.5445 11.545C13.7997 9.28925 16.9154 7.89453 20.3569 7.89453C22.8971 7.89453 25.2596 8.65434 27.2298 9.95938L24.7369 12.4523C23.4395 11.7321 21.9458 11.3216 20.3569 11.3216C17.8618 11.3216 15.6027 12.3329 13.9675 13.968C12.3324 15.6032 11.3212 17.8622 11.3212 20.3573C11.3212 22.8524 12.3324 25.1115 13.9675 26.7466C15.6027 28.3818 17.8618 29.393 20.3569 29.393C22.8519 29.393 25.111 28.3818 26.7462 26.7466C28.3813 25.1115 29.3926 22.8524 29.3926 20.3573C29.3926 18.7679 28.9821 17.2746 28.2619 15.9773L30.7548 13.4844C32.0599 15.4546 32.8197 17.8171 32.8197 20.3573C32.8197 23.7988 31.4249 26.9145 29.1692 29.1697C26.914 31.4254 23.7983 32.8202 20.3569 32.8202Z",
    fill: "#6699FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1645 1.65591V4.92676C35.1645 5.27008 35.4445 5.55012 35.7879 5.55012H39.0587C39.1809 5.55012 39.2843 5.6233 39.325 5.73774C39.3652 5.85218 39.3311 5.97432 39.2364 6.05079L34.4267 9.95216C33.9035 10.3769 33.3241 10.5821 32.6496 10.5821H32.4774H31.6747L21.1276 21.1286C20.7023 21.5545 20.0113 21.5545 19.586 21.1286C19.1601 20.7033 19.1601 20.0123 19.586 19.587L30.1325 9.03995V8.23723V8.06502C30.1325 7.39049 30.3377 6.81115 30.7625 6.28792L34.6638 1.4782C34.7403 1.38357 34.8619 1.34945 34.9769 1.38962C35.0913 1.43033 35.1645 1.53377 35.1645 1.65591Z",
    fill: "#6699FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9475 35.3161C33.3706 34.9591 33.7827 34.5811 34.1816 34.1822C34.5843 33.7795 34.9656 33.363 35.326 32.9355L23.3143 20.9238L22.1187 22.1194C21.6632 22.5755 21.0745 22.8176 20.4775 22.8462L32.9475 35.3161Z",
    fill: "#6699FF",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.357,
    cy: 20.3565,
    rx: 19.5519,
    ry: 19.5519,
    fill: "url(#paint0_linear_979_34961)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.357,
    cy: 20.3565,
    rx: 19.5519,
    ry: 19.5519,
    fill: "url(#paint1_linear_979_34961)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_979_34961",
    x1: 39.9089,
    y1: 39.9084,
    x2: 20.357,
    y2: 20.3565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADC5FF",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADC5FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_979_34961",
    x1: 0.805176,
    y1: 0.804688,
    x2: 20.357,
    y2: 20.3565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndianicShortLogo);
export default __webpack_public_path__ + "static/media/indianic-short-logo.3d697caefeaef63234cd24b0b2afe712.svg";
export { ForwardRef as ReactComponent };